import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

export const PostCover = ({
  style,
  className,
  gatsbyImage
}) => {
  return (
    <div style={style} className={`relative text-color-white ${className} xl:mx-[-70px]`}>
      <div className="absolute top-0 bottom-0 left-0 right-0">
        <GatsbyImage
          alt=""
          image={gatsbyImage}
          className="h-full w-full"
          objectFit="cover"
        />
      </div>
      <div className="post--cover-gradient md:hidden absolute top-0 left-0 h-full w-full" />
    </div>
  );
};
